import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router";
import "../../assets/css/style.css";
import "../../assets/css/login.css";
import { API } from "../../services/api";
import { getUserDetails } from "../../services/apiProfile";
import "../../assets/css/style_new.css";
import profileimg from "../../assets/img/profile/profile-img.svg"
import eye from "../../assets/img/profile/eye.svg"
import ProfileBio from "./ProfileBio";
import ProfileCommunity from "./ProfileCommunity";
import Spinner from "../../commonComponents/Spinner";
import chat from "../../assets/img/chat.svg"
import About from "./About";
const OrganizationProfile = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const data = location.state || {};
  const [userArr, setUserArr] = useState([]);
  const [isBio, setIsBio] = useState(false);
  const [loader, setLoader] = useState(false);
  const [isCommunity, setIsCommunity] = useState(false);
  const [about, setAbout] = useState({});
  const handleBioClose = () => setIsBio(false);
  const handleCommunityClose = () => setIsCommunity(false);
  const maxChars = 60;
  const user = JSON.parse(localStorage.getItem('userData'));

  useEffect(() => {

    if (user) {
      fetchUserDetails(data.userId);
    }
  }, [])
  const fetchUserDetails = async (id) => {
    setLoader(true)
    const formData = {
      userid: id,
      offset: 0,
      limit: 5
    }
    let listUserData = await getUserDetails(formData);
    setUserArr(listUserData);
    setAbout(listUserData.user);

    setLoader(false)


  };

  return (

    <div >
      {loader && <Spinner />}
      <div className="main">
        <div className="contents">
          <div className="profile_user">
            <div className="coverimage">
              <img src={
                userArr?.user?.coverImage?.url
                  ? API.uploadFilePath + userArr.user.coverImage?.url
                  : profileimg
              } alt="test" className="cover_profile" />
              <div className="overlay"></div>
            </div>
            <div className="profile_main d-flex align-items-start">
              <div className="profile_avatar  pr-img-with-button">
                <img src={
                  userArr?.user?.profileImage?.url
                    ? API.uploadFilePath + userArr.user.profileImage?.url
                    : profileimg
                } alt="test" className="cover_profile" />
               
              </div>
              <div className="profile_details flex-fill">
                <div className="avatarname_full d-flex-c">
                  <h3>{userArr?.user?.firstName}</h3>

                </div>
                <div className="avatar_other-details d-flex-c align-items-stretch">

                  <div className="details_itms w-50">
                    <h4>Description</h4>
                    <p>{userArr.user?.bio?.slice(0, maxChars)}
                      {userArr.user?.bio?.length > maxChars && <Link className="profile_edit" onClick={() => setIsBio(true)} >View more</Link>}
                    </p>
                  </div>



                  <div className="details_itms communities">
                    <h4>Communities</h4>
                    <ul className="profile_community d-flex flex-wrap" >
                      {userArr?.communities?.length > 4 ?
                        userArr.communities.slice(0, 3).map((community, index) => (
                          <li key={community._id}>
                            <img src={
                              community?.communityId?.profileImage?.url
                                ? API.uploadFilePath + community.communityId.profileImage.url
                                : profileimg
                            } alt="test" className="community_thumb" />
                            <span>{community?.communityId?.communityName} </span>
                          </li>)) :
                        userArr?.communities?.length === 1 ?
                          userArr?.communities?.map((community, index) => (
                            <li key={community._id} className="full-width">
                              <img src={
                                community?.communityId?.profileImage?.url
                                  ? API.uploadFilePath + community.communityId.profileImage.url
                                  : profileimg
                              } alt="test" className="community_thumb" />
                              <span>{community?.communityId?.communityName}</span>
                            </li>)) :
                          userArr?.communities?.map((community, index) => (
                            <li key={community._id}>
                              <img src={
                                community?.communityId?.profileImage?.url
                                  ? API.uploadFilePath + community.communityId.profileImage.url
                                  : profileimg
                              } alt="test" className="community_thumb" />
                              <span>{community?.communityId?.communityName}</span>
                            </li>))}

                      {userArr?.communities?.length > 4 &&
                        <li>
                          <Link href="#" className="viewall" onClick={() => setIsCommunity(true)}>
                            <img src={eye} alt="test" className="community_thumb" />
                            <span>View all </span>
                          </Link>
                        </li>}
                    </ul>
                  </div>

                </div>
              </div>
            </div>
          </div>



        </div>
        <About about={about} />

      </div>
      {isBio ? <ProfileBio isBio={isBio} handleClose={handleBioClose} name={userArr?.user?.userType === "Organization" ? userArr?.user?.firstName + " " + userArr?.user?.lastName : userArr?.user?.firstName} content={userArr?.user?.bio} /> : null}
      {isCommunity ? <ProfileCommunity isCommunity={isCommunity} handleClose={handleCommunityClose} community={userArr?.communities} /> : null}
    </div>
  );

};
export default OrganizationProfile;
